import { Box, ButtonBase, Snackbar } from '@material-ui/core';
import ReactDOM from 'react-dom';
import { CloseIcon } from '../components/Icon';

export const alertActionable = (type = 'msg', action) => {
  const ID = `actionableAlert-${type}`;
  if (document.getElementById(ID)) {
    // 防止重复
    return;
  }
  const alertEl = document.createElement('div');
  alertEl.setAttribute('id', ID);
  document.getElementById('root').appendChild(alertEl);
  if (type === 'msg') {
    ReactDOM.render(
      <Snackbar open={true} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <Box
          width="45rem"
          height="6rem"
          borderRadius="0.75rem"
          bgcolor="#FF655C"
          display="flex"
          justifyContent="center"
          alignItems="center"
          fontSize="1rem"
          color="#FFFFFF"
          fontWeight="700"
        >
          You have actionable item for admission cases. Kindly&nbsp;
          <ButtonBase
            style={{
              fontSize: '1rem',
              color: '#FFFFFF',
              fontWeight: '700',
              textDecorationLine: 'underline',
              fontStyle: 'italic',
            }}
            onClick={() => {
              closeAlert(ID);
              window.location.href = action.path;
            }}
          >
            click here
          </ButtonBase>
          &nbsp;to follow up.
          <CloseIcon
            style={{ marginLeft: '1.5rem', cursor: 'pointer' }}
            onClick={() => {
              closeAlert(ID);
              action?.callback?.();
            }}
          />
        </Box>
      </Snackbar>,
      alertEl
    );
  } else {
    ReactDOM.render(<audio src={action.audio} autoPlay onEnded={() => closeAlert(ID)} />, alertEl);
  }
};

const closeAlert = (ID) => {
  const targetEl = document.getElementById(ID);
  targetEl?.remove();
};
